import { AUTHZ_FEATURES } from '../../../constants/authz/features.constants';

const INTERVENE_DASHBOARD = AUTHZ_FEATURES.INTERVENE.DASHBOARD;
const INTERVENE_CALLING = AUTHZ_FEATURES.INTERVENE.CALLING;
const INTERVENE_CHAT = AUTHZ_FEATURES.INTERVENE.CHAT;

const INTERVENE_CHILD_FEATURES = [INTERVENE_CALLING, INTERVENE_CHAT];

const REPORTING_VIEW = AUTHZ_FEATURES.REPORTING.VIEW;
const ANALYTICS_VIEW = AUTHZ_FEATURES.ANALYTICS.VIEW;
const ANALYTICS_CHILD_FEATURES = [
  AUTHZ_FEATURES.ANALYTICS.CREATE,
  AUTHZ_FEATURES.ANALYTICS.DELETE,
  AUTHZ_FEATURES.ANALYTICS.EXPORT,
  AUTHZ_FEATURES.ANALYTICS.RECORDS,
  AUTHZ_FEATURES.ANALYTICS.WHATSAPP,
  AUTHZ_FEATURES.ANALYTICS.INTERVENE,
];

/**
 * Intervene: calling/chat require dashboard; revoking dashboard clears child features.
 * Analytics & Reporting: child features require view analytics and sidebar report access;
 * revoking view analytics / report access clears child features.
 *
 * @param {string} codename
 * @param {boolean} granted
 * @param {object} grants
 */
export function applyFeatureGrantSideEffects(codename, granted, grants) {
  const features = {
    ...(grants.features || {}),
    [codename]: Boolean(granted),
  };

  if (granted && INTERVENE_CHILD_FEATURES.includes(codename)) {
    features[INTERVENE_DASHBOARD] = true;
  }

  if (!granted && codename === INTERVENE_DASHBOARD) {
    INTERVENE_CHILD_FEATURES.forEach((key) => {
      features[key] = false;
    });
  }

  if (granted && ANALYTICS_CHILD_FEATURES.includes(codename)) {
    features[ANALYTICS_VIEW] = true;
    features[REPORTING_VIEW] = true;
  }

  if (granted && codename === ANALYTICS_VIEW) {
    features[REPORTING_VIEW] = true;
  }

  if (granted && codename === REPORTING_VIEW) {
    features[ANALYTICS_VIEW] = true;
  }

  if (!granted && (codename === ANALYTICS_VIEW || codename === REPORTING_VIEW)) {
    features[ANALYTICS_VIEW] = false;
    features[REPORTING_VIEW] = false;
    ANALYTICS_CHILD_FEATURES.forEach((key) => {
      features[key] = false;
    });
  }

  return {
    ...grants,
    features,
  };
}

/**
 * @param {object} grants
 */
export function normalizeFeatureGrantSideEffects(grants) {
  const features = grants?.features || {};
  let next = grants;

  if (features[INTERVENE_CALLING] || features[INTERVENE_CHAT]) {
    next = applyFeatureGrantSideEffects(INTERVENE_DASHBOARD, true, next);
  }

  const normalizedIntervene = next.features || {};
  if (!normalizedIntervene[INTERVENE_DASHBOARD]) {
    INTERVENE_CHILD_FEATURES.forEach((key) => {
      if (normalizedIntervene[key]) {
        next = applyFeatureGrantSideEffects(key, false, next);
      }
    });
  }

  const currentFeatures = next.features || {};
  if (ANALYTICS_CHILD_FEATURES.some((key) => currentFeatures[key])) {
    next = applyFeatureGrantSideEffects(ANALYTICS_VIEW, true, next);
  } else if (currentFeatures[ANALYTICS_VIEW] || currentFeatures[REPORTING_VIEW]) {
    next = applyFeatureGrantSideEffects(ANALYTICS_VIEW, true, next);
  }

  const normalizedAnalytics = next.features || {};
  if (!normalizedAnalytics[ANALYTICS_VIEW] || !normalizedAnalytics[REPORTING_VIEW]) {
    ANALYTICS_CHILD_FEATURES.forEach((key) => {
      if (normalizedAnalytics[key]) {
        next = applyFeatureGrantSideEffects(key, false, next);
      }
    });
  }

  return next;
}
